import React from "react"

const Benefits = () => {
  return (
    <section className="container mx-auto px-6 py-20">
      <h3 className="text-5xl font-bold pb-8 leading-snug">
        <span className="text-secondary font-bold block leading-tight">
          Benefits
        </span>
        are great!
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-6 gap-8">
        <div className="col-span-1 p-8 rounded-3xl font-semibold border-4 border-red-600">
          <span className="text-secondary">Access</span> to a global workforce 
        </div>
        <div className="lg:col-span-2 p-8 rounded-3xl font-semibold border-4 border-gray-900">
          <span className="text-secondary">Flexibility</span> and scalability to optimize cyclical processes and fluctuating needs
        </div>
        <div className="lg:col-span-3 p-8 rounded-3xl font-semibold border-4 border-gray-900">
          <span className="text-secondary">Hiring bridge</span> for short and long-term needs, a bridge to provide capacity, while a permanent team is being hired 
        </div>
        <div className="lg:col-span-3 p-8 rounded-3xl font-semibold border-4 border-gray-900">
          <span className="text-secondary">Specialized professionals</span> who set up a customized team and optimizes development times
        </div>
        <div className="lg:col-span-1 p-8 rounded-3xl font-semibold bg-primary text-white">
          <span className="text-secondary">Reduce</span>  costs and development times
        </div>
        <div className="lg:col-span-2 p-8 rounded-3xl font-semibold border-4 border-gray-900">
          <span className="text-secondary">Get access</span> to the best practices of the industry and continue improving yourself
        </div>
        <div className="lg:col-span-2 p-8 rounded-3xl font-semibold border-4 border-gray-900">
          <span className="text-secondary">Increased capacity</span>, to increase its productive capacity, and meet industry standards
        </div>
        <div className="lg:col-span-3 p-8 rounded-3xl font-semibold border-4 border-gray-900">
          <span className="text-secondary">Build an organization strategically</span>, with a flexible team and gain competitive advantage
        </div>
        <div className="lg:col-span-1 p-8 rounded-3xl font-semibold text-white bg-secondary">
        <span>Reduced "start-up"</span> cycle time
        </div>
      </div>

      <div className="py-12">
        <h3 className="font-bold text-secondary text-4xl md:text-6xl pb-12 lg:w-1/2">Software <span className="text-primary">Development</span></h3>
        <div className="font-bold text-3xl text-center md:text-left grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-secondary">Application<br /> Developers</div>
          <div className="md:col-span-2">System Analysts</div>
          <div className="md:col-span-2 md:text-center">Mobile<br /> Developers</div>
          <div className="text-secondary">The box<br /> Engineers</div>
          <div className="text-center">Software<br /> Architects</div>
          <div className="md:col-span-2 text-center">Development<br /> Managers</div>
          <div className="md:col-span-2 md:text-center">ERP<br /> Specialists</div>
          <div className="text-center">Web Developers</div>
          <div className="text-secondary">Java<br /> Developers</div>
          <div className="md:col-span-2 text-center">kotlin<br /> Developers</div>
        </div>
      </div>
    </section>
  )
}

export default Benefits
